import { AxiosResponse } from 'axios'
import { BookingResponse, Bookings, BookingWithPaymentResponse } from '../types/api.types'
import { AxiosService } from './axios.service'

const axiosService = AxiosService.getInstance()

export interface TripSegment {
  pickupAddress: string
  dropoffAddress: string
  scheduledAt: string // ISO8601 format
  scheduledTz: string // timezone
  flightName?: string
}

export interface CreateBookingRequest {
  vehicleId: string
  tripSegments: TripSegment[]
  // Booking-level additional info
  passengerCount?: number
  luggage?: string
  pickupSign?: string
  bookingForSomeoneElse?: boolean
  guestFullName?: string
  guestEmail?: string
  guestPhoneNumber?: string
}

export class BookingService {
  createBooking(
    data: CreateBookingRequest,
    token?: string,
  ): Promise<AxiosResponse<BookingResponse>> {
    const url = '/bookings'
    return axiosService.postWithToken<BookingResponse>(url, data, token)
  }

  createBookingWithPayment(
    data: CreateBookingRequest,
    token?: string,
  ): Promise<AxiosResponse<BookingWithPaymentResponse>> {
    const url = '/bookings/with-payment'
    return axiosService.postWithToken<BookingWithPaymentResponse>(url, data, token)
  }

  getBooking(id: string, token: string): Promise<AxiosResponse<any>> {
    const url = `/v1/bookings/${id}`
    return axiosService.getWithToken<any>(url, {}, token)
  }

  getCustomerBookings(): Promise<AxiosResponse<Bookings[]>> {
    const url = `/bookings`
    return axiosService.getWithToken<Bookings[]>(url, {})
  }

  // Legacy method - keeping for backward compatibility
  getPastBookings(): Promise<AxiosResponse<Bookings[]>> {
    return this.getCustomerBookings()
  }
}
